import React from 'react';
import './PageTitleHeader.scss';

// todo: Move page header and subheader classes to this component
export const PageTitleHeader = ({ title, subtitle }) => (
    <div className={'page-title-header'}>
        <div className="ph-title" children={title}></div>
        {subtitle && <div className="ph-subtitle" children={subtitle}></div>}
    </div>
);
